module.exports = __webpack_public_path__ + "static/media/character.bbf01d4f.png";